import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../../Config';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getMasterIATAAgentContactDetail } from '../../../../../Redux/action/MasterAction';


const EditContact = ({
    contact_id,
    token,
    user_id,
    b64id,
    show,
    handleClose,
    refreshContact,
}) => {
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);

    useEffect(() => {
        if (contact_id) {
            dispatch(getMasterIATAAgentContactDetail(token, user_id, contact_id))
        }
    }, [contact_id]);



    const {
        loadingMasterIATAAgentContactDetail,
        MasterIATAAgentContactDetail,
        MasterIATAAgentContactDetailError
    } = useSelector(state => state.MasterReducer);

    const initialValues = {
        iata_agent_id: 0,
        company_branch_division: "",
        branch_id: 0,
        branch_name: "",
        contact_person_id: 0,
        contact_person_name: "",
        designation: "",
        mobile: "",
        email: ""
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }

                let iata_agent_id = atob(b64id);
                if (iata_agent_id) {
                    values.iata_agent_id = iata_agent_id
                } else {
                    toast.error("Can't add address.");
                    return;
                }
                if (!contact_id) {
                    toast.error("Can't find customer support details.")
                } else {
                    values.id = contact_id
                }
                axios.post(`${adminMainUrl}/api/iata-agent/contact/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshContact();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        // console.log("MasterIATAAgentContactDetail",MasterIATAAgentContactDetail)
        if (MasterIATAAgentContactDetail) {
            formik.setFieldValue("company_branch_division", MasterIATAAgentContactDetail.company_branch_division);
            formik.setFieldValue("branch_name", MasterIATAAgentContactDetail.branch_name);
            formik.setFieldValue("contact_person_name", MasterIATAAgentContactDetail.contact_person_name);
            formik.setFieldValue("designation", MasterIATAAgentContactDetail.designation);
            formik.setFieldValue("email", MasterIATAAgentContactDetail.email);
            formik.setFieldValue("mobile", MasterIATAAgentContactDetail.mobile);
        }
    }, [MasterIATAAgentContactDetail])


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Contact</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit} >
                        <div className="row">
                            <div className="col-md-6">
                                <label htmlFor="company_branch_division" className='form-label mb-0'>
                                    Select
                                </label>
                                <select
                                    className='form-control form-control-sm'
                                    id="company_branch_division"
                                    name="company_branch_division"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.company_branch_division}
                                >
                                    <option value="">-Select a value-</option>
                                    <option value="Company">Company</option>
                                    <option value="Branch">Branch</option>
                                    <option value="Division">Division</option>
                                </select>

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="branch_name" className='form-label mb-0'>
                                    Branch Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="branch_name"
                                    name='branch_name'
                                    value={formik.values.branch_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="contact_person_name" className='form-label mb-0'>
                                    Contact Person
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="contact_person_name"
                                    name='contact_person_name'
                                    value={formik.values.contact_person_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="designation" className='form-label mb-0'>
                                    Designation
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="designation"
                                    name='designation'
                                    value={formik.values.designation}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="email" className='form-label mb-0'>
                                    Email
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="email"
                                    name='email'
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={250}
                                />
                            </div>
                            <div className="col-md-6">
                                <label htmlFor="mobile" className='form-label mb-0'>
                                    Mobile
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="mobile"
                                    name='mobile'
                                    value={formik.values.mobile}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    maxLength={15}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^0-9]/g, '');
                                        event.target.value = value;
                                    }}

                                />
                            </div>

                        </div>
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditContact